import { Link } from "react-router-dom";
import { APP_NAME } from "../constants/navigation";

const BrandMark = () => {
  return (
    <Link
      to="/"
      className="flex items-baseline gap-2 font-['DM_Sans'] rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-[#468BFF]/50"
    >
      <span className="text-lg font-semibold tracking-[-0.3px] text-[#1a202c]">
        DR
      </span>
      <span className="text-lg font-medium tracking-[-0.3px] text-gray-500 hidden sm:inline">
        Company Research
      </span>
      <span className="sr-only sm:hidden">{APP_NAME}</span>
    </Link>
  );
};

export default BrandMark;
